export enum BFXNotificationSubType {
  ACCEPTANCE_NEW,
  ACCEPTANCE_MODIFY_IN,
  ACCEPTANCE_MODIFY_OUT,
  ACCEPTANCE_CANCEL,
  ACCEPTANCE_EXPIRY,
  ACCEPTANCE_TRIGGER_EXPIRY,
  ACCEPTANCE_MIGRATION,
  ACCEPTANCE_TRANSFER,
  CREDIT_FAIL_ENTRY,
  MODIFY_FAIL_ENTRY,
  CREDIT_FAIL_REVAL,
  CREDIT_FAIL_FILL,
  CREDIT_FAIL_FORCE_DI,
  CREDIT_FAIL_REJECTED,
  STREAM_OFF_RATE_STALE,
  STREAM_OFF_STREAM_OFF,
  SAVE_USER_PROFILE_SUCCESS,
  SAVE_BLOTTER_LAYOUT_SUCCESS,
  //failure subtypes
  ACCEPTANCE_FAIL,
  REJECTIONS_FAIL,
  APPROVE_FILL_FAIL,
  CANCEL_FILL_FAIL,
  CLEAR_FILL_FAIL,
  ABORT_FAIL,
  APPROVE_FAIL,
  QUICK_FILL_FAIL,
  DETAIL_FILL_FAIL,
  TRADE_CONFIRM_FAIL,
  TRADE_CANCEL_FAIL,
  REACTIVATE_FAIL,
  UNLOCK_FAIL,
  MODIFY_OUT_FAIL,
  SAVE_USER_PROFILE_FAIL,
  SAVE_BLOTTER_LAYOUT_FAIL,
  //Fill subtypes
  FILL_FULL,
  FILL_PART,
  FILL_WITHHELD,
  FILL_NOT_RECIEVED,
  //unlock
  DETAIL_FILL_UNLOCK,
  // manual price
  MANUAL_PRICE_FAIL,
  // fwd roll
  FWD_ROLL_PRICE,
  // unsolicited
  UNSOLICITED_PAUSE,
  UNSOLICITED_RESUME,
  CONNECTION_MONITOR_CONNECTED,
  CONNECTION_MONITOR_DISCONNECTED,
  CONNECTION_MONITOR_OUT_OF_SERVICE,
  CONNECTION_MONITOR_UNKNOWN,
  CREDIT_FAIL_CANCELEXPIRY,
  ALGO_INFLIGHT_ALERT,
  ALGO_INFLIGHT_PAUSE,
  ALGO_INFLIGHT_CANCEL,
  ALGO_INFLIGHT_ENABLE_FAIL,
  ALGO_INFLIGHT_DISABLE_FAIL,

  FWD_FILL_TIMEOUT,
  MESSAGE,
  POSITION,
  GENERIC_ERROR,

  FIXING_RATE_REQUIREMENT,

  FILL_NOW_FAIL,
  FILL_NOW_LOCK_FAIL,

  PAUSE_FAIL,
  RESUME_FAIL,

  ENTRY,
  BENCHMARK_ENTRY,

  NETTING_FAILED,
}
